<template>
  <span style="color: inherit; font-family: imagine">
    {{ showTxt }}
  </span>
</template>

<script>
export default {
  props: ['num'],
  data() {
    return {
      amount: 0,
      fromArr: [],
      toArr: [],
      arrIndx: 0,
      showTxt: '',

      timer:''
    }
  },
  watch: {
    num(val) {
      if (this.amount == 0) {
        this.fromArr = new Array(val.toString().length).fill(0)
        this.toArr = val.toString().split('')
        this.arrIndx = 0
        this.amount = val
        this.randomTo()
      }
    },
  },
  methods: {
    randomTo(maxNum) {
      var that = this
      this.arrIndx = 0
      let golb // 为了清除requestAnimationFrame
      function numSlideFun() {
        // 数字动画
        if (that.fromArr[that.arrIndx] == that.toArr[that.arrIndx]) {
          that.arrIndx += 1
        }
        else{
          that.fromArr[that.arrIndx] = parseInt(that.fromArr[that.arrIndx]) + 1
        }
        that.initTxt()
      }
      this.timer = window.setInterval(numSlideFun,100) // 调用数字动画
    },
    initTxt() {

      //console.log(this.fromArr)
      let num = this.fromArr.join('')
      num = parseInt(num)
      var re = /(?=(?!\b)(\d{3})+$)/g
      this.showTxt = num.toString().replace(re, ',')
    },
  },
  mounted() {
    if (this.num) {
      this.fromArr = new Array(this.num.toString().length).fill(0)
      this.toArr = this.num.toString().split('')
      this.amount = this.num
      this.arrIndx = 0
      this.randomTo()
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/tools/random-number.vue